/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintModalAnnulla
 * @restrict E
 * @description Componente per avviare l'annullamento di una proposta di carta debito internazionale
 */
(function () {
  'use strict';
  var CdintModalAnnullaCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModalInstance
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModalInstance = $uibModalInstance;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Note inserite nella textarea
     */
    this.note;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Funzione abbinata al pulsante di chiusura in alto e annulla in basso
     * Chiude la modale senza avviare la chiamata di annullamento
     */
    this.chiudiModale = function () {
      self.$uibModalInstance.dismiss();
    };

    /**
     * Funzione abbinata al pulsante "conferma" della modale, avvia la chiamata di annullamento
     */
    this.annullaProposta = function () {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avvio annullamento per la pratica ID ' + self.idPratica
      );

      self.propostaCartaDebitoIntSrvc
        .promiseAnnullaPratica(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
            ? self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica,
          self.note
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Annullamento completato per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            self.$uibModalInstance.close(true);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore annullamento per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };
  };

  CdintModalAnnullaCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModalInstance'
  ];

  angular.module('cbl.cartadebitoint.wa').controller('cdintModalAnnullaController', CdintModalAnnullaCtrl);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintModalAnnulla/cdintModalAnnulla.cmpt.js
// module id = 10
// module chunks = 0